import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import FormsPage from './FormsPage.js';

export default WithGASetup(FormsPage, AuthContext);
